import { useTranslation } from 'react-i18next'

const TeacherEnd = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="teacher-after-title"
      fill="none"
      {...props}
    >
      <title id="teacher-after-title">{t('antagonists:teacher:components:end')}</title>
      <defs>
        <clipPath id="teacher-b">
          <path
            d="M1505.68 210.97c-83.11 16.64-61.65 69.58-128.17 128.28-66.52 58.71-85.44 209.41-3.28 279.85 82.19 70.45 114.95 44.69 212.77 32.95 97.82-11.74 224.34-44.61 224.96-150.56.9-150.42-102.78-169.22-134.08-224.01-31.3-54.78-76.58-85.66-172.19-66.52Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="teacher-c">
          <path
            d="M1689.19 570.66s-9.98 26.84-75.38 43.52c-60.05 15.33-108-25.67-108-25.67l-91.63 29.76s11.15 64.65 27.77 142.52c20.62 96.54 53.07 171.69 47.22 198.2-10.59 47.86-78.77 191.53-94.32 302.64-32.87 235.02-32.9 452.41-32.9 452.41s111.81 60.78 310.9 50.52c198.79-10.23 273.75-60.58 273.75-60.58s-1.06-240.48-59.15-486.6c-28.47-120.63-138.74-253.04-124-327.1 5.6-28.08 6.3-67.17-1.96-166.9-8.97-108.33-13.73-149.22-13.73-149.22l-58.59-3.47.03-.03Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:none}.e{fill:#ef821b}.f{fill:#ef8227}.g{fill:#f2c900}.h{fill:#6b562a}.i{fill:#6b5738}.j{fill:#d297bf}.k{fill:#dfbe84}.l{fill:#2a6196}.m{clip-path:url(#teacher-c)}.n{clip-path:url(#teacher-b)}'
          }
        </style>
      </defs>
      <path
        d="M1505.68 210.97c-83.11 16.64-61.65 69.58-128.17 128.28-66.52 58.71-85.44 209.41-3.28 279.85 82.19 70.45 114.95 44.69 212.77 32.95 97.82-11.74 224.34-44.61 224.96-150.56.9-150.42-102.78-169.22-134.08-224.01-31.3-54.78-76.58-85.66-172.19-66.52Z"
        style={{
          fill: '#6b562a',
        }}
      />
      <g
        style={{
          clipPath: 'url(#teacher-b)',
        }}
      >
        <path
          d="M1518.31 192.45s16.53 51.5 22.45 84.82c5.94 33.35 5.72 48.79 5.72 48.79l8.88-.48s-4.62-23.99-9.61-56.24c-4.99-32.25-24.15-82.89-24.15-82.89l-3.28 5.97v.03Z"
          style={{
            fill: '#dfbe84',
          }}
        />
      </g>
      <path
        d="m1448.29 645.79 143.11 67.34 148.71-98.22 4.26-29.68s-26.7-3.98-63.19-18.02c-36.48-14.04-58.93-103.82-58.93-103.82l-97.21 20.65s26.2 78.21-24.3 106.26c-50.5 28.05-55.26 21.8-55.26 21.8l2.8 33.68Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1689.19 570.66s-9.98 26.84-75.38 43.52c-60.05 15.33-108-25.67-108-25.67l-91.63 29.76s11.15 64.65 27.77 142.52c20.62 96.54 53.07 171.69 47.22 198.2-10.59 47.86-78.77 191.53-94.32 302.64-32.87 235.02-32.9 452.41-32.9 452.41s111.81 60.78 310.9 50.52c198.79-10.23 273.75-60.58 273.75-60.58s-1.06-240.48-59.15-486.6c-28.47-120.63-138.74-253.04-124-327.1 5.6-28.08 6.3-67.17-1.96-166.9-8.97-108.33-13.73-149.22-13.73-149.22l-58.59-3.47.03-.03Z"
        style={{
          fill: '#ef8227',
        }}
      />
      <g
        style={{
          clipPath: 'url(#teacher-c)',
        }}
      >
        <path
          d="M1667.22 319.67c155.18-57.64 330.29 1.09 395.08 161.69 60.42 149.72.17 341.95-182.7 414.25-182.81 72.32-343.18-49.96-389.05-185.25-45.82-135.29 3.95-326.59 176.65-390.71l.03.03Z"
          style={{
            fill: 'none',
          }}
        />
        <path
          d="M1599.83 636.6c60.27-5.49 88.61-32.81 101.66-45.84 13.06-13.03 24.88-49.37 24.88-49.37l-58.71-33.91-174.8 50.89-16.95 27.41s23.48 59.99 123.91 50.89v-.06Z"
          style={{
            fill: '#f2c900',
          }}
        />
      </g>
      <path
        d="M1590.42 530.14c36.74-10.03 64-66.19 72.91-86.2s13.62-56.72-16.53-78.24c-50.07-35.78-67.03-66.16-98.16-61.7-31.13 4.46-28.02 30.29-61.03 68.15-23.62 27.1-25.25 74.37 3.67 101.05 28.92 26.7 74.68 63.61 99.17 56.94h-.03Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1589.91 455.44c7.87-.59 16.48.17 17.09 5.55 1.54 13.93-11.91 23.59-23.68 27.18-10.7 3.25-35.53-5.66-37.77-14.26-1.63-6.16 3.05-8.91 11.46-12.36 6.56-2.69 12.75-.06 15.97-.48 6.25-.87 7.87-4.99 16.95-5.66l-.03.03Z"
        style={{
          fill: '#d297bf',
        }}
      />
      <path
        d="M1598.49 377.14c.92-1.06 2.38-2.19 4.12-2.97l-1.99-16.11 3.08-.87 2.35 16.2c1.09-.06 2.21.2 3.42.59l7.15-9.28 2.66 1.46-5.91 10.2c.56.53 1.32.98 1.74 1.57l10.56-5.63 1.85 2.61-11.18 5.91c.98 3.17.53 6.61-1.12 9.5-2.44 4.26-8.6 6.75-13.93 3.17-7.12-4.76-5.86-12.69-2.77-16.34h-.03ZM1526.78 388.07c-1.06-.95-2.69-1.88-4.51-2.44l.95-16.73-3.19-.48-1.29 16.87c-1.09.08-2.19.48-3.31 1.04l-8.41-8.38-2.44 1.79 7.34 9.47c-.5.59-1.18 1.15-1.49 1.79l-13.65-3.73-1.49 2.83 14.32 3.92c-.5 3.31.42 6.7 2.47 9.36 3.03 3.95 9.5 5.66 14.29 1.4 6.39-5.69 4.01-13.45.42-16.7l-.03-.03Z"
        style={{
          fill: '#2a6196',
        }}
      />
      <path
        d="M1534.65 361.48s-18.16-.06-30.96 1.51c-10.56 1.29-21.77 7.45-21.77 7.45l-.64-4.9s14.07-11.52 25.08-12.19c11.01-.67 28.78-1.88 28.78-1.88l-.48 10ZM1583.91 356.38c.84-.22 20.34-4.68 34.5-4.82 10.73-.11 19.05 3.61 19.05 3.61l-.31-4.93s-17.4-11.21-28.36-9.78c-10.96 1.43-27.29 6.22-27.29 6.22l2.38 9.72.03-.03Z"
        style={{
          fill: '#6b5738',
        }}
      />
      <path
        d="M1354.16 1001.19s-14.43 57.56-29.56 116.99c-14.52 57.16-29.68 116.09-33.18 127.28-7.12 22.81-32.53 71.51-30.63 82.19 1.91 10.7 14.1 59.13 15.97 63.83 5.3 13.39 42.73 39.03 42.73 39.03s4.57-12.22-1.99-25.22c-4.12-8.15-18.75-23.59-13.73-48.42 4.34-21.44 4.93-39.59 17.35-34.55 9.67 3.92-.11 35.06 1.99 47.22 2.27 13.14 13.31 15.94 13.31 15.94s12.3-55.71 13.84-72.07c1.49-15.69-1.88-66.38-.7-78.38.56-5.77 22.47-62.57 37.83-108.89 16.59-50.05 28.67-100.88 28.67-100.88l-61.9-24.07Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1415.92 617.93s-43.66 15.05-53.19 42.87c-15.78 46.1 9.56 213.44-7.93 320.65-2.55 15.69-17.51 59.49-26.51 99.95-12.81 57.67-22.45 93.82-22.45 93.82s20.85 7.48 38.28 12.22c17.4 4.76 30.12 6.75 30.12 6.75s16.45-38.73 31.75-79.36c13.31-35.36 33.29-97.88 38.84-116.4 7.9-26.31 31.05-157.82 27.55-224.82-3.53-67-56.46-155.69-56.46-155.69Z"
        style={{
          fill: '#ef821b',
        }}
      />
      <path
        d="M1874 939.46s25.16 53.72 51.34 109.2c25.16 53.35 51.28 108.3 56.86 118.59 11.35 21.02 30.8 73.95 30.1 84.79-.7 10.84-7.51 60.3-8.85 65.21-3.78 13.87-38.19 43.49-38.19 43.49s-5.86-11.63-.78-25.3c3.19-8.55 16.06-25.5 8.32-49.63-6.67-20.85-9.25-38.81-21.04-32.45-9.19 4.96 3.95 34.83 3.19 47.16-.81 13.31-11.46 17.32-11.46 17.32s-18.35-54-21.69-70.14c-3.19-15.44 4.79-68.04 1.37-79.58-1.65-5.55-33.99-57.14-57.92-99.67-25.84-45.96-47.39-93.54-47.39-93.54l56.16-35.45Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1745.8 573.49s47.39 3.7 61.79 29.37c23.85 42.48 31.08 214.7 67.67 316.98 5.35 14.96 28.02 55.34 44.19 93.51 23.03 54.39 39.06 88.21 39.06 88.21s-19.14 11.12-35.42 18.94-28.41 12.08-28.41 12.08-23.2-35.11-45.59-72.3c-19.5-32.37-50.47-90.23-59.29-107.44-12.53-24.46-45-159.58-67.78-216.1-25.08-62.24 23.79-163.26 23.79-163.26Z"
        style={{
          fill: '#ef821b',
        }}
      />
    </svg>
  )
}

export default TeacherEnd
